export default {
  install: (app) => {
    app.config.errorHandler = (err, vm, info) => {
      if (process.env.NODE_ENV === 'development') {
        console.group('>>>>>> 错误信息 >>>>>>')
        console.log(info)
        console.groupEnd();
        console.group('>>>>>> Vue 实例 >>>>>>')
        console.log(vm)
        console.groupEnd();
        console.group('>>>>>> Error >>>>>>')
        console.log(err)
        console.groupEnd();
      }
    }
    app.config.warnHandler = (msg, vm, trace) => {
      const ignoreMsg = [
        'Vue received a Component which was made a reactive object',
        'Extraneous non-props',
        '"className" is already defined',
        'Data property "formatter" is already defined in Props',
        'Data property "labelFormatter" is already defined in Props',
        'Added non-passive event listener to a scroll-blocking',
        //   数字prop传字符串
        'Expected Number with value']
      const ignore = ignoreMsg.some((el) => {
        return msg.includes(el)
      })
      if (!ignore) {
        console.warn(msg, trace)
      }
    }
  }
}
